var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import Text from "../Text/Text";
import React from "react";
/**
 *
 * @param {{
 *  onChange?: import('react').ChangeEventHandler;
 *  variant?: import('./inputVariants').InputVariant;
 *  placeholder?: string;
 *  [x: string]: any;
 * }} props
 * @returns
 */
function TextInput(_a, ref) {
    var { onChange, variant = "default", placeholder } = _a, rest = __rest(_a, ["onChange", "variant", "placeholder"]);
    return (_jsx(Text, Object.assign({ as: "input", 
        // @ts-ignore type="text" is passed to the input DOM elemeent.
        type: "text", onChange: onChange, placeholder: placeholder, sx: {
            padding: 2, // This is partially overriden by variants.
            color: "lightText",
            // Using inset box shadows because the Zeplin designs use inner borders,
            // and I wouldn't have the same total heights otherwise.
            border: 0,
            boxShadow: (theme) => { var _a; return `inset 0 0 0 1px ${(_a = theme.colors) === null || _a === void 0 ? void 0 : _a.border};`; },
            variant: `input.${variant}`,
            "::placeholder": { color: "border" },
        }, ref: ref }, rest)));
}
export default React.forwardRef(TextInput);
//# sourceMappingURL=TextInput.js.map